import langRoofCal from '@/apps/RoofCal/lang/';
import urlApis from '@/apps/RoofCal/apis/';
export default {
	langRoofCal: langRoofCal,
	urlApis: urlApis,
	access: false,
	asideStorage:[],
	typeStep: 0,
}
